<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="'全部公告'" name="2"></el-tab-pane>
      <el-tab-pane label="未读公告" name="0"></el-tab-pane>
      <el-tab-pane label="已读公告" name="1"></el-tab-pane>
    </el-tabs>
    <br>
    <div class="board_header">
      <el-date-picker v-model="bulletinDate" type="daterange" placeholder="选择日期" start-placeholder="开始日期" range-separator="至" end-placeholder="结束日期" :editable="false" value-format="yyyy-MM-dd" @change="dateChange"></el-date-picker>
      <el-input ref="bulletinInput" v-model="bulletinSearch" style="width:240px;margin-left:20px;" placeholder="请输入发布人/公告标题" prefix-icon="el-icon-search" @keyup.enter.native="onBeginSearch"></el-input>
    </div>
    <br>
    <el-table tooltip-effect="light" style="width: 100%" :data="articles_arr">
      <el-table-column align="left" prop="issueTime" width="50" height="527">
        <template slot-scope="scope">
          <div style="display:flex;align-item:center">
            <img v-if="scope.row.statu === 1" src="@/assets/images/read.png" alt srcset style="width:28px;">
            <img v-else src="@/assets/images/unread.png" alt srcset>
            <!-- <span style="margin-left:20px">{{onReturnCreateTime(scope)}}</span> -->
          </div>
        </template>
      </el-table-column>
      <el-table-column align="left" prop="issueTime" label="发布时间" width="280" height="527">
        <template slot-scope="scope">
          <!-- <div style="display:flex;align-item:center">
                        <img src="@/assets/images/read.png" v-if="scope.row.statu === 1" alt srcset style="width:28px;">
                        <img src="@/assets/images/unread.png" v-else alt srcset>
                        <span style="margin-left:20px">{{onReturnCreateTime(scope)}}</span>
                    </div> -->
          <span>{{ onReturnCreateTime(scope) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" prop="issuer" label="发布人" width="250"></el-table-column>
      <el-table-column align="left" prop="title" label="公告标题" width="350">
        <template slot-scope="scope">
          <span class="board_title">{{ scope.row.title }} </span>
        </template>
      </el-table-column>
      <el-table-column align="left" prop="content" label="公告内容">
        <template slot-scope="scope">
          <span class="board_title" style="width:350px">{{ scope.row.content }} </span>
        </template>
      </el-table-column>
      <el-table-column align="left" prop="readNum" width="200" label="阅读量"></el-table-column>
      <el-table-column align="left" prop="average" width="100" label="操作">
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="showBulletinDetail(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <br>
    <el-pagination background :page-size="pageSize" layout="prev, pager, next, jumper" :total="articles.length" @current-change="currentChange"></el-pagination>
    <el-dialog :append-to-body="true" title="公告详情" :visible.sync="dialogVisible" width="1101px">
      <el-container>
        <el-header>{{ bulletinDetail.title }}</el-header>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <el-main v-html="bulletinDetail.content"></el-main>
        <br>
        <el-footer>
          <el-row type="flex" justify="space-between">
            <span>
              <i class="el-icon-view"></i>
              {{ bulletinDetail.readNum }}
            </span>
            <span>{{ bulletinDetail.issueTime }}</span>
          </el-row>
        </el-footer>
      </el-container>
    </el-dialog>
    <el-dialog :append-to-body="true" title="新增公告" :visible.sync="dialogVisible2" width="701px">
      <el-form ref="form" :model="form" label-width="80px" :rules="rules">
        <el-form-item label="公告标题" prop="title">
          <el-input v-model="form.title" placeholder="请输入公告标题" maxlength="25" style="width:240px;"></el-input>
          <span style="color: #999999;font-size: 12px;margin-left: 10px;">25个字以内</span>
        </el-form-item>
        <el-form-item label="公告内容" prop="content">
          <el-input v-model="form.content" type="textarea" maxlength="10" placeholder="请输入公告内容" style="width:414px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary">发布</el-button>
          <el-button @click="dialogVisible2 = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import { queryArticles, checkArticle } from './api';

export default {
  data() {
    return {
      activeName: '2',
      bulletinDate: [],
      bulletinSearch: '',
      dialogVisible: false,
      dialogVisible2: false,
      form: {
        title: '',
        content: ''
      },
      rules: {
        title: [
          { required: true, message: '标题不能为空', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '内容不能为空', trigger: 'blur' },
          {
            min: 1, max: 2000, message: '长度在 2000 个字以内', trigger: 'blur'
          }
        ]
      },
      pageNo: 1,
      pageSize: 10,
      total: 0,
      articles: [],
      articles_arr: [],
      bulletinDetail: {}
    };
  },
  activated() {
    this.onGetQueryArticles();
  },
  methods: {
    handleClick() {
      this.pageNo = 1;
      this.bulletinDate === null ? this.bulletinDate = [] : '';
      this.onGetQueryArticles();
    },
    dateChange() {
      this.pageNo = 1;
      this.bulletinDate === null ? this.bulletinDate = [] : '';
      this.onGetQueryArticles();
    },
    // 搜索
    onBeginSearch() {
      this.pageNo = 1;
      this.$refs.bulletinInput.blur();
      this.onGetQueryArticles();
    },
    // 查询公告列表页展示功能
    onGetQueryArticles() {
      const data = {
        beginTime:
                    this.bulletinDate[0] === undefined
                      ? ''
                      : this.bulletinDate[0],
        endTime:
                    this.bulletinDate[1] === undefined
                      ? ''
                      : this.bulletinDate[1],
        text: this.bulletinSearch,
        num: Number(this.activeName),
        statu: 1
      };
      queryArticles(sessionStorage.getItem('mainId'), data).then((res) => {
        this.articles = res.data;
        this.articles_arr = this.articles.slice(0, this.pageSize);
      });
    },
    // 分页切换页面
    currentChange(val) {
      val * this.pageSize > this.articles.length
        ? (this.articles_arr = this.articles.slice(
          (val - 1) * this.pageSize,
          this.articles.length
        ))
        : (this.articles_arr = this.articles.slice(
          (val - 1) * this.pageSize,
          val * this.pageSize
        ));
    },
    // 查看公告详情
    showBulletinDetail(row) {
      const vm = this;
      this.dialogVisible = true;
      this.bulletinDetail = row;
      // //console.log(row);
      // row.statu = 1

      // if(!row.isread ){
      //     row.readNum++
      //     row.isread = true
      // }
      checkArticle({ id: row.id }).then((res) => {
        // console.log(res);
        if (res.code === 0) {
          if (row.statu === 0) {
            vm.onGetQueryArticles();
          }
        }
      });
    },
    onReturnCreateTime(scope) {
      return dayjs(scope.row.times).format('YYYY-MM-DD HH:mm');
    }
  }
};
</script>

<style lang="less" scoped>
.board_header {
    display: flex;
}
.el-header {
    background-color: #f5f7fa;
    height: 46px !important;
    color: #818691;
    text-align: center;
    line-height: 46px;
    font-size: 14px;
}
.el-main {
    border: solid 1px #e6ebf5;
    height: 514px;
}
.el-footer {
    padding: 0;
    height: 20px !important;
}
.board_title {
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    height: auto;
    white-space: nowrap;
    width: 250px;
    margin-top: 5px;
}
</style>
